import "../../Scripts/jquery-ui-1.12.1.min.js";
function spellcheck(path, query, hitsCutoff, tags) {
    $.ajax({
        url: path + "/_spellcheck?query=" + encodeURIComponent(query) + "&size=1",
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        success: function (data) {

            var hits = data.hits || [];
            var suggestions = hits
                .map(function(hit) { return hit.suggestion })
                .filter(function(suggestion) { return suggestion !== query });

            if (suggestions.length > 0) {
                var suggestion = suggestions[0];

                $("#suggestion").html("Mente du: " + "<a href='?q=" + suggestion + "'>" + suggestion + "</a> ?");
                $("#suggestion").slideDown();
            }
        }
    });
}

(function ($) {

    var get = [];
    location.search.replace('?', '').split('&').forEach(function (val) {
        var split = val?.split("=", 2);
        get[split[0]] = split[1];
    });

    //$('#from').datetimepicker({
    //    locale: 'nb',
    //    format: 'DD.MM.YYYY',
    //    useCurrent: false
    //});
    //$('#to').datetimepicker({
    //    locale: 'nb',
    //    format: 'DD.MM.YYYY',
    //    useCurrent: false
    //});
    $("#from").on("dp.change", function (e) {
        $('#to').data("DateTimePicker").minDate(e.date);
    });
    $("#to").on("dp.change", function (e) {
        $('#from').data("DateTimePicker").maxDate(e.date);
    });

    $(".search-filter ul.category-list li i").click(function (item) {
        $(this).parent().toggleClass("closed");
    });

   $("#datepicker-form").submit(function (e) {
        e.preventDefault();

        var url = window.location.href;

        if ($("#from").val()) {
            var separator = (url.indexOf("?") === -1) ? "?" : "&",
            newParam = separator + "from=" + $("#from").val();
            let newUrl = url.replace(newParam, "");
            newUrl += newParam;
            url = newUrl;

        }

        if ($("#to").val()) {
            var separator = (url.indexOf("?") === -1) ? "?" : "&",
                newParam = separator + "to=" + $("#to").val();
            let newUrl = url.replace(newParam, "");
            newUrl += newParam;
            url = newUrl;
        }

        window.location.href = url;

    });


    $(".search-input-text").autocomplete({
        source: function (request, response) {
            $.ajax({
                url: "/find_v2/_autocomplete?prefix=" + encodeURIComponent(request.term) + "&size=5",
                dataType: "json",
                contentType: 'application/json; charset=utf-8',
                success: function (data) {
                    response($.map(data.hits, function (item) {
                        return {
                            label: item.query,
                            value: item.query
                        };
                    }));
                }
            });
        },
        minLength: 2,

        //select
        select: function (e, ui) {
            location.href = "/finn/?q=" + ui.item.value;
        }
    });

    $("#header-search-button").click(function() {
        openSearch();
    });

    function openSearch() {
        $("#shortMenu").hide(400);
        $("#searchInput").addClass("search-input-full-width");
        $("#header-search-button-active").show();
        $("#header-search-button").hide();
        $("#my-page").hide();
        $("#accessibility-textsize").hide();
        $("#accessibility-browsealoud").hide();
        $("#theme-toggler").hide();

        setTimeout(function () {
            $("#searchInput").focus();
        }, 400);

    }

    function closeSearch() {
        $("#searchInput").removeClass("search-input-full-width");
        $("#header-search-button-active").hide();
        $("#header-search-button").show();
        

        setTimeout(function() {
            $("#accessibility-textsize").show();
            $("#accessibility-browsealoud").show();
            $("#my-page").show();
            $("#shortMenu").show(400);
            $("#theme-toggler").show();
        }, 400);
    }

    $(document.body).click(function () {
        if ($("#searchInput").hasClass("search-input-full-width")) {
            closeSearch();
        }

    });

    $(".js-block-click").click(function (e) {
        e.stopPropagation(); // this stops the event from bubbling up to the body
    });

})(jQuery);
